import React from 'react';
import { ERROR_DISPLAY_STYLES, GENERATOR_NAMES } from 'common/components/CopyMagic/constants';
import { useConfigContext, useUiResourceContext } from '../../contexts';
import ErrorMessageFullscreen from './ErrorMessageFullscreen';
import ErrorMessageInline from './ErrorMessageInline';
import ErrorMessageDefault from './ErrorMessageDefault';

import './style.scss';

const GENERATORS_DISPLAY_DEFAULT_ERROR = [
  GENERATOR_NAMES.COURSE_OUTLINE,
  GENERATOR_NAMES.CONTENT_ASSISTANT,
  GENERATOR_NAMES.HEADLINE_ASSISTANT,
] as const;

const ErrorMessage = () => {
  const { generatorName } = useConfigContext();
  const { error } = useUiResourceContext();

  if (!error) return null;

  if (GENERATORS_DISPLAY_DEFAULT_ERROR.some((g) => g === generatorName)) {
    return <ErrorMessageDefault />;
  }

  switch (error.displayStyle) {
    case ERROR_DISPLAY_STYLES.FULLSCREEN:
      return <ErrorMessageFullscreen />;
    case ERROR_DISPLAY_STYLES.INLINE:
      return <ErrorMessageInline />;
    default:
      return null;
  }
};

export default ErrorMessage;
